// extracted by mini-css-extract-plugin
export var button = "_6k-4";
export var hasDarkBackground = "_6k-7";
export var hasLightBackground = "_6k-6";
export var iconWrapper = "_6k-0";
export var large = "_6k-2";
export var medium = "_6k-1";
export var small = "_6k-5";
export var xsmall = "_6k-3";